var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo691(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Yes_logo_rgb",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128.686,
    height: 80,
    viewBox: "0 0 128.686 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1739",
    "data-name": "Rectangle 1739",
    width: 128.686,
    height: 80,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "YES_8757_RGB"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5747",
    "data-name": "Group 5747",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1954",
    "data-name": "Path 1954",
    d: "M127.717,21.993l-6.678,38.049-.616,3.519a17.013,17.013,0,0,1-2.917,7.5A13.949,13.949,0,0,1,107.2,77.2l-34.3-.757-49.754-1.1c-.178.017-.35.034-.528.045a11.686,11.686,0,0,1-7.094-1.906,12.105,12.105,0,0,1-4.806-6.1L2.052,40.715a16.067,16.067,0,0,1,1.18-12.024A11.248,11.248,0,0,1,10.764,23L108.958,2.279a15.686,15.686,0,0,1,2.392-.33,15.392,15.392,0,0,1,12.829,5.676,16.493,16.493,0,0,1,3.535,14.365",
    transform: "translate(-0.993 -1.379)",
    fill: "#00b7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1955",
    "data-name": "Path 1955",
    d: "M129.98,25.43l-6.769,38.543-.006.028-.539,3.086a15.277,15.277,0,0,1-3.533,7.96c-.014.014-.025.037-.04.051a12.363,12.363,0,0,1-8.325,4.38L87.1,78.956h-.277L26.7,77.623a10.118,10.118,0,0,1-4.9-.692.619.619,0,0,1-.065-.025,10.612,10.612,0,0,1-5.941-6.275L7.139,43.98c-1.508-4.247-.553-13.944,7.644-15.816l98.2-20.713c11.151-2.333,19.324,8.6,17,17.98",
    transform: "translate(-4.696 -5.118)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1956",
    "data-name": "Path 1956",
    d: "M161.808,208.43l-.006.028-.539,3.086a15.277,15.277,0,0,1-3.533,7.96l-32.3,3.9-60.134-1.327a10.151,10.151,0,0,1-4.9-.692c-.023-.006-.042-.017-.065-.023L161.8,208.433Z",
    transform: "translate(-43.294 -149.572)",
    fill: "#001541"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1957",
    "data-name": "Path 1957",
    d: "M148.166,207.022,34.486,220.746l-4.5-9.293L150.207,196.13Z",
    transform: "translate(-21.521 -140.746)",
    fill: "#fbb53b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1958",
    "data-name": "Path 1958",
    d: "M75.477,108.041l12.016-1.7L88.34,97.8,76.321,99.5l.494-4.967,14.02-1.988.9-9.107-24.751,3.5L56.916,88.37,48.964,102.2l-5.4-11.939L31.34,91.991l11.208,21.272L41.153,127.34l10.787-1.528,1.395-14.074L66.619,90.644l-3.329,33.562,25.525-3.615.9-9.107-14.791,2.1Z",
    transform: "translate(-22.49 -59.878)",
    fill: "#001541"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1959",
    "data-name": "Path 1959",
    d: "M259.017,80.825c3.442-.489,6.794-.093,8.9,1.087l.986-9.937a25.367,25.367,0,0,0-9.892-.333c-8.782,1.242-14.949,6.76-15.641,13.747-.709,7.142,3.256,9.028,8.983,10.513,3.8.991,6.142,1.375,5.989,2.928-.133,1.344-1.937,2.163-5.171,2.621a20.3,20.3,0,0,1-10.44-1.429l-1.025,10.349a27.867,27.867,0,0,0,11.1.418c9.655-1.367,15.314-6.354,16.017-13.442.689-6.935-3.581-8.83-9.29-10.471-3.595-1.022-5.764-1.632-5.628-2.979.15-1.5,2.084-2.643,5.114-3.072",
    transform: "translate(-173.454 -51.183)",
    fill: "#001541"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1960",
    "data-name": "Path 1960",
    d: "M344.608,160.532a6.9,6.9,0,0,0-6.215,6.334c-.342,3.437,1.624,5.224,5.12,4.73a6.9,6.9,0,0,0,6.215-6.334c.342-3.439-1.624-5.227-5.12-4.73",
    transform: "translate(-242.808 -115.141)",
    fill: "#001541"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1961",
    "data-name": "Path 1961",
    d: "M358.355,57.4l-10.8,1.528L346.06,85.04l8.579-1.214Z",
    transform: "translate(-248.337 -41.191)",
    fill: "#001541"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1962",
    "data-name": "Path 1962",
    d: "M86.094,95.551l12.018-1.7.844-8.539-12.016,1.7.491-4.967,14.02-1.985.9-9.11L77.6,74.454,67.536,75.88,59.581,89.712l-5.4-11.939L41.96,79.5l11.208,21.272L51.773,114.85l10.784-1.525,1.395-14.077L77.236,78.154l-3.327,33.562L99.434,108.1l.9-9.11-14.789,2.1Z",
    transform: "translate(-30.111 -50.915)",
    fill: "#ffefc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1963",
    "data-name": "Path 1963",
    d: "M269.627,68.335c3.442-.489,6.794-.093,8.9,1.087l.986-9.937a25.367,25.367,0,0,0-9.892-.333c-8.782,1.242-14.949,6.76-15.641,13.747-.709,7.142,3.256,9.028,8.983,10.513,3.8.991,6.142,1.375,5.989,2.928-.133,1.344-1.937,2.163-5.171,2.621a20.324,20.324,0,0,1-10.44-1.429L252.32,97.881a27.918,27.918,0,0,0,11.1.418c9.655-1.367,15.314-6.354,16.017-13.442.689-6.935-3.581-8.83-9.29-10.471-3.595-1.022-5.764-1.632-5.628-2.979.15-1.5,2.084-2.643,5.114-3.072",
    transform: "translate(-181.068 -42.22)",
    fill: "#ffefc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1964",
    "data-name": "Path 1964",
    d: "M355.218,148.042A6.9,6.9,0,0,0,349,154.376c-.342,3.437,1.624,5.224,5.12,4.73a6.9,6.9,0,0,0,6.215-6.334c.342-3.439-1.624-5.227-5.12-4.73",
    transform: "translate(-250.422 -106.178)",
    fill: "#ffefc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1965",
    "data-name": "Path 1965",
    d: "M368.968,44.91l-10.807,1.531L356.67,72.55l8.582-1.214Z",
    transform: "translate(-255.951 -32.228)",
    fill: "#ffefc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1966",
    "data-name": "Path 1966",
    d: "M89.866,99.274,77.587,118.581,68.87,102.118l-.72.127,9.053,17.1-1.293,12.08.706-.059L77.9,119.389,90.769,99.15Z",
    transform: "translate(-48.905 -71.151)",
    fill: "#00b7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1967",
    "data-name": "Path 1967",
    d: "M194.321,87.334V86.6l-15.729,2.256-2.982,29.08,15.805-2.236.056-.717-15.077,2.14,1.372-13.4,13.111-1.855.045-.714-13.083,1.858,1.387-13.543Z",
    transform: "translate(-126.02 -62.145)",
    fill: "#00b7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1968",
    "data-name": "Path 1968",
    d: "M373.933,60.882,372.01,80.276l.712-.119,1.92-19.377Z",
    transform: "translate(-266.96 -43.617)",
    fill: "#00b7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1969",
    "data-name": "Path 1969",
    d: "M366.56,163.363a1.357,1.357,0,0,0-1.124,1.161.9.9,0,0,0,.918,1.028.983.983,0,0,0,.155-.011,1.357,1.357,0,0,0,1.124-1.161.936.936,0,0,0-.268-.777.962.962,0,0,0-.8-.24m.381.946a.661.661,0,0,1-.528.539.256.256,0,0,1-.223-.054.251.251,0,0,1-.059-.206.661.661,0,0,1,.528-.539.417.417,0,0,1,.059,0,.243.243,0,0,1,.167.056.245.245,0,0,1,.059.2h0Z",
    transform: "translate(-262.238 -117.224)",
    fill: "#00b7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1970",
    "data-name": "Path 1970",
    d: "M270.248,81.829c-.785,2.79.09,5.67,2.039,6.7a21.251,21.251,0,0,0,2.923,1.152c.638.22,1.324.455,2.05.731,1.132.432,2.115.779,2.968,1.079.469.164.9.316,1.285.457,2.9,1.062,4.066,2.869,3.465,5.371-1.917,7.992-13.6,7.836-17.536,7.15l-.051.7a23.447,23.447,0,0,0,3.9.291c5.278,0,12.8-1.451,14.368-7.975.48-1.994.192-4.685-3.9-6.187q-.589-.216-1.293-.46c-.847-.3-1.827-.644-2.951-1.073-.734-.28-1.426-.517-2.07-.737a21,21,0,0,1-2.824-1.11c-1.663-.881-2.392-3.417-1.694-5.9.505-1.8,3.072-7.616,14.952-6.879l.093-.686c-12.4-.762-15.173,5.45-15.712,7.376",
    transform: "translate(-191.883 -53.384)",
    fill: "#00b7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1971",
    "data-name": "Path 1971",
    d: "M431.428,189.132a1.231,1.231,0,1,1,1.234-1.254,1.226,1.226,0,0,1-1.234,1.254m0-2.318a1.086,1.086,0,1,0,1.062,1.11,1.076,1.076,0,0,0-1.062-1.11m-.065.3a.819.819,0,0,1,.483.088.459.459,0,0,1,.2.412.43.43,0,0,1-.265.426l.285.618h-.409l-.206-.556h-.181v.556h-.37v-1.542h.46Zm-.093.689h.195c.144,0,.2-.051.2-.189s-.062-.184-.2-.184h-.189v.373Z",
    transform: "translate(-308.717 -133.957)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1972",
    "data-name": "Path 1972",
    d: "M54.828,255.866c.522-.062.771.184.74.743l-.184,3.327-.887.107.076-1.375-.641.076-.076,1.375-.887.107.184-3.327a.878.878,0,0,1,.83-.932Zm-.858,2.194.641-.076.076-1.375a.113.113,0,0,0-.031-.085.1.1,0,0,0-.082-.028l-.4.048a.131.131,0,0,0-.088.048.153.153,0,0,0-.04.093l-.076,1.375Z",
    transform: "translate(-38.012 -183.606)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1973",
    "data-name": "Path 1973",
    d: "M64.533,255.16l-.226,4.1-.887.107.226-4.1.887-.107Z",
    transform: "translate(-45.511 -183.106)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1974",
    "data-name": "Path 1974",
    d: "M69.45,256.748l-.093,1.68-.887.107.226-4.1,1.579-.189q.788-.093.74.74l-.025.474a.743.743,0,0,1-.4.689q.309.076.288.483l-.09,1.621-.887.107.085-1.553c.006-.085-.034-.121-.113-.113l-.424.051Zm.1-1.819-.065,1.2.469-.057a.131.131,0,0,0,.088-.048.153.153,0,0,0,.04-.093l.051-.943a.113.113,0,0,0-.031-.085.1.1,0,0,0-.085-.028l-.469.056Z",
    transform: "translate(-49.135 -182.444)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1975",
    "data-name": "Path 1975",
    d: "M84.213,255.812l.034-.633.844-.1-.028.531a.877.877,0,0,1-.83.932l-.8.1c-.522.062-.771-.184-.74-.74l.141-2.553a.878.878,0,0,1,.83-.932l.8-.1c.522-.062.771.184.74.743l-.023.387-.844.1.028-.494a.113.113,0,0,0-.031-.085.1.1,0,0,0-.085-.028l-.4.048a.131.131,0,0,0-.088.048.153.153,0,0,0-.04.093l-.152,2.762a.113.113,0,0,0,.031.085.1.1,0,0,0,.085.028l.4-.048a.131.131,0,0,0,.088-.048.153.153,0,0,0,.04-.093Z",
    transform: "translate(-59.34 -181.059)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1976",
    "data-name": "Path 1976",
    d: "M95.069,251.846l-.141,2.553a.877.877,0,0,1-.833.932l-.842.1q-.788.093-.74-.74l.141-2.553a.879.879,0,0,1,.833-.932l.842-.1c.525-.062.771.184.74.743Zm-1.034,2.762.152-2.762a.113.113,0,0,0-.031-.085.1.1,0,0,0-.085-.028l-.4.048a.131.131,0,0,0-.088.048.153.153,0,0,0-.04.093l-.152,2.762a.113.113,0,0,0,.031.085.1.1,0,0,0,.085.028l.4-.048A.131.131,0,0,0,94,254.7.153.153,0,0,0,94.035,254.608Z",
    transform: "translate(-66.387 -180.19)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1977",
    "data-name": "Path 1977",
    d: "M105.138,253.935l-.887.107.186-3.4a.113.113,0,0,0-.031-.085.1.1,0,0,0-.085-.028l-.342.042a.131.131,0,0,0-.088.048.153.153,0,0,0-.04.093l-.186,3.4-.887.107.184-3.326a.878.878,0,0,1,.83-.932l.785-.1c.525-.062.771.184.74.743l-.184,3.327Z",
    transform: "translate(-73.756 -179.301)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1978",
    "data-name": "Path 1978",
    d: "M114.665,248.856c.522-.062.771.184.74.74l-.133,2.426a.877.877,0,0,1-.833.932l-1.629.2.226-4.1,1.629-.2Zm-.285,3.377.144-2.637a.113.113,0,0,0-.031-.085.1.1,0,0,0-.085-.028l-.52.062-.158,2.889.52-.062a.131.131,0,0,0,.088-.048.153.153,0,0,0,.04-.093Z",
    transform: "translate(-80.954 -178.576)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    d: "M124.383,247.93l-.226,4.1-.887.107.226-4.1Z",
    transform: "translate(-88.46 -177.918)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1980",
    "data-name": "Path 1980",
    d: "M128.133,247.872l.042-.754,2.217-.268-.042.754-.666.082-.184,3.346-.887.107.184-3.346-.666.082Z",
    transform: "translate(-91.948 -177.143)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1981",
    "data-name": "Path 1981",
    d: "M137.463,246.35l-.226,4.1-.887.107.226-4.1.887-.107Z",
    transform: "translate(-97.847 -176.784)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1982",
    "data-name": "Path 1982",
    d: "M144.092,245.926l-.141,2.553a.877.877,0,0,1-.833.932l-.844.1c-.522.062-.771-.184-.74-.74l.141-2.553a.878.878,0,0,1,.83-.932l.844-.1c.522-.062.771.184.74.743Zm-1.034,2.762.152-2.762a.113.113,0,0,0-.031-.085.1.1,0,0,0-.085-.028l-.4.048a.131.131,0,0,0-.088.048.153.153,0,0,0-.04.093l-.152,2.762a.113.113,0,0,0,.031.085.1.1,0,0,0,.085.028l.4-.048a.131.131,0,0,0,.088-.048.153.153,0,0,0,.04-.093Z",
    transform: "translate(-101.564 -175.942)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1983",
    "data-name": "Path 1983",
    d: "M154.148,248.015l-.887.107.186-3.4a.113.113,0,0,0-.031-.085.1.1,0,0,0-.085-.028l-.342.042a.131.131,0,0,0-.088.048.138.138,0,0,0-.04.093l-.186,3.4-.887.107.184-3.327a.878.878,0,0,1,.83-.932l.785-.1q.788-.093.74.74l-.184,3.327Z",
    transform: "translate(-108.927 -175.052)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1984",
    "data-name": "Path 1984",
    d: "M162.933,243.28l-.226,4.1-.887.107.226-4.1Z",
    transform: "translate(-116.124 -174.581)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1985",
    "data-name": "Path 1985",
    d: "M169.2,246.2l-.887.107.186-3.4a.113.113,0,0,0-.031-.085.1.1,0,0,0-.085-.028l-.342.042a.131.131,0,0,0-.088.048.153.153,0,0,0-.04.093l-.186,3.4-.887.107.184-3.327a.878.878,0,0,1,.83-.932l.785-.1c.522-.062.771.184.74.743L169.2,246.2Z",
    transform: "translate(-119.727 -173.746)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1986",
    "data-name": "Path 1986",
    d: "M178.266,243.5l.037-.652,1.172-.141-.082,1.508a.877.877,0,0,1-.83.932l-.8.1c-.522.062-.771-.184-.74-.743l.141-2.553a.878.878,0,0,1,.83-.932l.8-.1c.522-.062.771.184.74.743l-.023.387-.842.1.028-.494a.113.113,0,0,0-.031-.085.1.1,0,0,0-.085-.028l-.4.048a.131.131,0,0,0-.088.048.153.153,0,0,0-.04.093l-.152,2.762a.113.113,0,0,0,.031.085.1.1,0,0,0,.082.028l.4-.048a.131.131,0,0,0,.088-.048.153.153,0,0,0,.04-.093l.054-.957Z",
    transform: "translate(-127.033 -172.878)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1987",
    "data-name": "Path 1987",
    d: "M191.286,245.284a.712.712,0,0,1-.87-.8,1.072,1.072,0,0,1,.969-1.025.712.712,0,0,1,.87.8,1.067,1.067,0,0,1-.969,1.022Z",
    transform: "translate(-136.644 -174.702)",
    fill: "#ffefc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1988",
    "data-name": "Path 1988",
    d: "M203.054,240.413l-.088,1.61-.887.107.226-4.1.887-.107-.093,1.717.7-.085.093-1.717.887-.107-.226,4.1-.887.107.088-1.61Z",
    transform: "translate(-145.015 -170.598)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1989",
    "data-name": "Path 1989",
    d: "M213.576,240.195l.983-.119-.04.734-1.869.226.226-4.1,1.869-.226-.04.723-.983.119-.054.963.918-.11-.04.7-.918.11Z",
    transform: "translate(-152.601 -169.866)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1990",
    "data-name": "Path 1990",
    d: "M222.518,235.606c.522-.062.771.184.74.743l-.184,3.327-.887.107.076-1.375-.641.076-.076,1.375-.887.107.184-3.327a.878.878,0,0,1,.83-.932Zm-.856,2.194.641-.076.076-1.375a.113.113,0,0,0-.031-.085.1.1,0,0,0-.085-.028l-.4.048a.131.131,0,0,0-.088.048.153.153,0,0,0-.04.093l-.076,1.375Z",
    transform: "translate(-158.349 -169.067)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1991",
    "data-name": "Path 1991",
    d: "M230.933,235.452l.042-.754,2.217-.268-.042.754-.666.079-.184,3.346-.887.107.184-3.346-.666.079Z",
    transform: "translate(-165.719 -168.23)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1992",
    "data-name": "Path 1992",
    d: "M240.243,233.94l-.226,4.1-.887.107.226-4.1Z",
    transform: "translate(-171.603 -167.879)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1993",
    "data-name": "Path 1993",
    d: "M246.508,236.855l-.887.107.186-3.4a.113.113,0,0,0-.031-.085.1.1,0,0,0-.085-.028l-.342.042a.131.131,0,0,0-.088.048.153.153,0,0,0-.04.093l-.186,3.4-.887.107.184-3.327a.878.878,0,0,1,.83-.932l.785-.1c.522-.062.771.184.74.743l-.184,3.327Z",
    transform: "translate(-175.205 -167.044)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1994",
    "data-name": "Path 1994",
    d: "M255.576,234.164l.037-.652,1.172-.141-.082,1.508a.877.877,0,0,1-.83.932l-.8.1q-.788.093-.74-.74l.141-2.553a.879.879,0,0,1,.833-.932l.8-.1c.522-.062.771.184.74.74l-.023.387-.844.1.028-.494a.113.113,0,0,0-.031-.085.1.1,0,0,0-.085-.028l-.4.048a.131.131,0,0,0-.088.048.153.153,0,0,0-.04.093l-.152,2.762a.113.113,0,0,0,.031.085.1.1,0,0,0,.085.028l.4-.048a.131.131,0,0,0,.088-.048.152.152,0,0,0,.04-.093l.054-.957-.33.04Z",
    transform: "translate(-182.511 -166.183)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1995",
    "data-name": "Path 1995",
    d: "M268.776,235.932a.711.711,0,0,1-.87-.8,1.067,1.067,0,0,1,.969-1.022.712.712,0,0,1,.87.8A1.067,1.067,0,0,1,268.776,235.932Z",
    transform: "translate(-192.252 -167.992)",
    fill: "#ffefc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1996",
    "data-name": "Path 1996",
    d: "M281.377,228.726c.522-.062.771.184.74.74l-.045.819a.878.878,0,0,1-.83.932l-.717.088-.088,1.61-.887.107.226-4.1,1.6-.195Zm-.2,1.768.056-1.019a.113.113,0,0,0-.031-.085.1.1,0,0,0-.082-.028l-.494.059-.071,1.274.494-.059a.131.131,0,0,0,.088-.048.153.153,0,0,0,.04-.093Z",
    transform: "translate(-200.609 -164.13)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1997",
    "data-name": "Path 1997",
    d: "M290.062,231.235l.969-.119-.042.748-1.858.223.226-4.1.887-.107-.184,3.352Z",
    transform: "translate(-207.484 -163.53)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1998",
    "data-name": "Path 1998",
    d: "M298.525,226.457l.887-.107-.184,3.327a.877.877,0,0,1-.83.932l-.785.1c-.522.062-.771-.184-.74-.74l.184-3.327.887-.107-.186,3.4a.113.113,0,0,0,.031.085.1.1,0,0,0,.085.028l.342-.042a.131.131,0,0,0,.088-.048.153.153,0,0,0,.04-.093l.186-3.4Z",
    transform: "translate(-213.039 -162.432)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    d: "M307.667,229.018l-.887.107.184-3.326a.878.878,0,0,1,.83-.932l.469-.056a.61.61,0,0,1,.644.226.862.862,0,0,1,.675-.384l.469-.056c.525-.062.771.184.74.743l-.184,3.327-.887.107.186-3.4a.113.113,0,0,0-.031-.085.1.1,0,0,0-.085-.028l-.342.042a.131.131,0,0,0-.088.048.153.153,0,0,0-.04.093l-.186,3.4-.887.107.186-3.4a.113.113,0,0,0-.031-.085.1.1,0,0,0-.085-.028l-.342.042a.131.131,0,0,0-.088.048.153.153,0,0,0-.04.093l-.186,3.4Z",
    transform: "translate(-220.15 -161.167)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    d: "M324.186,225.4c.268.065.4.271.376.621l-.04.734a.879.879,0,0,1-.833.932l-1.629.2.226-4.1,1.579-.189q.788-.093.74.74l-.02.373a.743.743,0,0,1-.4.689Zm-.559,1.564.051-.918a.113.113,0,0,0-.031-.085.1.1,0,0,0-.082-.028l-.52.062-.065,1.172.52-.062a.131.131,0,0,0,.088-.048.153.153,0,0,0,.04-.093Zm-.02-2.742-.469.056-.059,1.1.469-.056a.131.131,0,0,0,.088-.048.153.153,0,0,0,.04-.093l.045-.841a.113.113,0,0,0-.031-.085.1.1,0,0,0-.085-.028Z",
    transform: "translate(-231.115 -160.449)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2001",
    "data-name": "Path 2001",
    d: "M333.453,222.67l-.226,4.1-.887.107.226-4.1Z",
    transform: "translate(-238.492 -159.791)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2002",
    "data-name": "Path 2002",
    d: "M339.718,225.6l-.887.107.186-3.4a.113.113,0,0,0-.031-.085.1.1,0,0,0-.085-.028l-.342.042a.131.131,0,0,0-.088.048.153.153,0,0,0-.04.093l-.186,3.4-.887.107.184-3.327a.878.878,0,0,1,.83-.932l.785-.1q.788-.093.74.74l-.184,3.327Z",
    transform: "translate(-242.094 -158.963)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2003",
    "data-name": "Path 2003",
    d: "M348.789,222.887l.037-.652,1.172-.141-.082,1.508a.877.877,0,0,1-.833.932l-.8.1c-.522.062-.771-.184-.74-.743l.141-2.553a.878.878,0,0,1,.83-.932l.8-.1c.525-.062.771.184.74.743l-.023.387-.844.1.028-.494a.113.113,0,0,0-.031-.085.1.1,0,0,0-.085-.028l-.4.048a.131.131,0,0,0-.088.048.153.153,0,0,0-.04.093l-.153,2.762a.113.113,0,0,0,.031.085.1.1,0,0,0,.085.028l.4-.048a.131.131,0,0,0,.088-.048.153.153,0,0,0,.04-.093l.054-.957-.33.04Z",
    transform: "translate(-249.4 -158.088)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2004",
    "data-name": "Path 2004",
    d: "M361.946,224.672a.711.711,0,0,1-.87-.8,1.067,1.067,0,0,1,.969-1.022.712.712,0,0,1,.87.8A1.067,1.067,0,0,1,361.946,224.672Z",
    transform: "translate(-259.112 -159.912)",
    fill: "#ffefc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2005",
    "data-name": "Path 2005",
    d: "M373.666,220.855l.983-.119-.04.734-1.869.226.226-4.1,1.869-.226-.04.723-.983.119-.054.963.918-.11-.04.7-.918.11-.054.983Z",
    transform: "translate(-267.483 -155.988)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2006",
    "data-name": "Path 2006",
    d: "M381.662,220.175l.969-.119-.042.748-1.858.223.226-4.1.887-.107-.184,3.352Z",
    transform: "translate(-273.217 -155.593)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2007",
    "data-name": "Path 2007",
    d: "M389.306,218.965l.983-.119-.04.734-1.869.226.226-4.1,1.869-.226-.04.723-.983.119-.054.963.918-.11-.04.7-.918.11-.054.983Z",
    transform: "translate(-278.707 -154.631)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2008",
    "data-name": "Path 2008",
    d: "M398.053,217.885l.034-.633.844-.1-.028.531a.876.876,0,0,1-.83.932l-.8.1c-.525.062-.771-.184-.74-.743l.141-2.553a.879.879,0,0,1,.833-.932l.8-.1c.522-.062.771.184.74.743l-.023.387-.844.1.028-.494a.113.113,0,0,0-.031-.085.1.1,0,0,0-.085-.028l-.4.048a.131.131,0,0,0-.088.048.153.153,0,0,0-.04.093l-.152,2.762a.113.113,0,0,0,.031.085.1.1,0,0,0,.085.028l.4-.048a.131.131,0,0,0,.088-.048.152.152,0,0,0,.04-.093Z",
    transform: "translate(-284.556 -153.84)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2009",
    "data-name": "Path 2009",
    d: "M406.023,214.3l.042-.754,2.217-.268-.042.754-.666.082-.184,3.346-.887.107.184-3.346-.666.079Z",
    transform: "translate(-291.366 -153.053)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2010",
    "data-name": "Path 2010",
    d: "M415.2,214.968l-.093,1.68-.887.107.226-4.1,1.579-.189q.788-.093.74.74l-.025.474a.748.748,0,0,1-.4.689q.309.076.288.483l-.09,1.621-.887.107.085-1.553c.006-.085-.034-.121-.113-.113l-.424.051Zm.1-1.819-.065,1.2.469-.056a.131.131,0,0,0,.088-.048.153.153,0,0,0,.04-.093l.051-.943a.113.113,0,0,0-.031-.085.1.1,0,0,0-.082-.028Z",
    transform: "translate(-297.25 -152.462)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2011",
    "data-name": "Path 2011",
    d: "M425.3,211.58l-.226,4.1-.887.107.226-4.1Z",
    transform: "translate(-304.405 -151.833)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2012",
    "data-name": "Path 2012",
    d: "M430.9,213.915l.034-.633.844-.1-.028.531a.878.878,0,0,1-.83.932l-.8.1c-.522.062-.771-.184-.74-.743l.141-2.553a.878.878,0,0,1,.83-.932l.8-.1c.522-.062.771.184.74.743l-.023.387-.844.1.028-.494a.113.113,0,0,0-.031-.085.1.1,0,0,0-.082-.028l-.4.048a.131.131,0,0,0-.088.048.153.153,0,0,0-.04.093l-.153,2.762a.113.113,0,0,0,.031.085.1.1,0,0,0,.085.028l.4-.048a.131.131,0,0,0,.088-.048.153.153,0,0,0,.04-.093Z",
    transform: "translate(-308.13 -150.991)",
    fill: "#043673"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo691);
export default __webpack_public_path__ + "static/media/logo_691.04ff746881ecb381adb9de3138644710.svg";
export { ForwardRef as ReactComponent };